

window.main = true;

if (!window.prefetch) {
    angular.bootstrap(document.body, ['app']);
    require('./app.js');
}


//////////////////
// WEBPACK FOOTER
// ./js/bootstrap.js
// module id = ./js/bootstrap.js
// module chunks = 1